module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont_principal"
  }, [_c('div', {
    staticClass: "cont_error"
  }, [_c('h1', [_vm._v("Oops")]), _vm._v(" "), _c('p', [_vm._v("You don't have the permission to visit this page.")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Back to home")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf9faa54","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ErrorPages/NoPermission.vue
// module id = 768
// module chunks = 2